import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Services() {
  return (
    <>
        <Nav />
        <Header />
        <section class="wrapper inner-banner-wrapper testimonial-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2>Services</h2>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper custom-wrapper top-services">
          <div class="container inner container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-300">We provide reliable Application Development and maintenance services to help client to meet their strategic business objectives and fulfill their goals. We cover the various areas of Web Development , Designing, E-commerce ,Application , SEO Services . We have proven and highly appreciable track record in development, designing, managing and transforming applications for a wide range of clients.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <ul class="list-unstyled services-list our-services">
                  <li>
                    <div class="service-icon hi-icon glyph">
                      <div class="hvr-pulse" data-icon="&#xe00e;" aria-hidden="true"></div>
                    </div>
                    <div class="service-des">
                      <h4>Web Designing</h4>
                      <p>We have been offering Web Design, Web Development Services for more than a decade and building best quality application solutions for diverse industries.</p>
                    </div>
                  </li>
                  <li>
                    <div class="service-icon hi-icon glyph">
                      <div class="hvr-pulse" data-icon="&#xe07a;" aria-hidden="true"></div>
                    </div>
                    <div class="service-des">
                      <h4>E-commerce solutions</h4>
                      <p>We offers the most quality based , Customer oriented, User Friendly , Well arranged E-Commerce Website with the best online retail store in today's market.</p>
                    </div>
                  </li>
                  <li>
                    <div class="service-icon hi-icon glyph">
                      <div class="hvr-pulse" data-icon="&#xe0f7;" aria-hidden="true"></div>
                    </div>
                    <div class="service-des">
                      <h4>SEO Service</h4>
                      <p>We provide best SEO service in INDIA. Our SEO service has gain a large amount of visitors to increase online business. We consider the high quality SEO strategy to provide best online marketing and high ROI.</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-sm-6">
                <ul class="list-unstyled services-list our-services">
                  <li>
                    <div class="service-icon hi-icon glyph">
                      <div class="hvr-pulse" data-icon="&#xe038;" aria-hidden="true"></div>
                    </div>
                    <div class="service-des">
                      <h4>Web Development</h4>
                      <p>Our web Development process includes Several stages of planning , strategy , research , immense level of testing and on-time delivery.</p>
                    </div>
                  </li>
                  <li>
                    <div class="service-icon hi-icon glyph">
                      <div class="hvr-pulse" data-icon="&#xe00b;" aria-hidden="true"></div>
                    </div>
                    <div class="service-des">
                      <h4>Mobile App Development</h4>
                      <p>We develop Mobile Application such as Android / IOS / Windows with latest Technology to provide best quality mobile app solutions.</p>
                    </div>
                  </li>
                  <li>
                    <div class="service-icon hi-icon glyph">
                      <div class="hvr-pulse" data-icon="&#xe035;" aria-hidden="true"></div>
                    </div>
                    <div class="service-des">
                      <h4>Testing and Support</h4>
                      <p>We believe your business the most important aspect to us . A business is based upon high end applications and core logical ground so we give best support service with quality testing.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <Footer />
    </>
  )
}

export default Services